<template>
  <div>
    <b-form-checkbox v-model="includeVersatile">
      Include Versatile with Attack and Defense
    </b-form-checkbox>
    <b-form-checkbox v-model="includeAny" :disabled="disableAnyCheckbox">
      Include ANY with individual character
    </b-form-checkbox>
    <b-table-simple caption-top responsive class="compact-table-sm">
      <b-thead>
        <b-tr>
          <b-th rowspan="2" class="">Character</b-th>
          <b-th colspan="5" class="border-right">Unique cards</b-th>
          <b-th colspan="5" class="border-right border-left">Total cards</b-th>
          <b-th colspan="3" class="border-left">Total value</b-th>
        </b-tr>
        <b-tr>
          <b-th class="text-center attack">
            <UnmatchedCardIcon class="icon-padfix" cardType="attack" />
          </b-th>
          <b-th class="text-center versatile">
            <UnmatchedCardIcon class="icon-padfix" cardType="versatile" />
          </b-th>
          <b-th class="text-center defense">
            <UnmatchedCardIcon class="icon-padfix" cardType="defence" />
          </b-th>
          <b-th class="text-center scheme"
            ><UnmatchedCardIcon
              class="icon-padfix"
              cardType="scheme"
              fitWidth="1em"
              fitHeight="1.25em"
            />
          </b-th>
          <b-th class="text-center total">Total</b-th>

          <b-th class="text-center attack">
            <UnmatchedCardIcon class="icon-padfix" cardType="attack" />
          </b-th>
          <b-th class="text-center versatile">
            <UnmatchedCardIcon class="icon-padfix" cardType="versatile" />
          </b-th>
          <b-th class="text-center defense">
            <UnmatchedCardIcon class="icon-padfix" cardType="defence" />
          </b-th>
          <b-th class="text-center scheme"
            ><UnmatchedCardIcon
              class="icon-padfix"
              cardType="scheme"
              fitWidth="1em"
              fitHeight="1.25em"
            />
          </b-th>
          <b-th class="text-center total">Total</b-th>

          <b-th class="text-center attack">
            <UnmatchedCardIcon class="icon-padfix" cardType="attack" />
          </b-th>
          <b-th class="text-center versatile">
            <UnmatchedCardIcon class="icon-padfix" cardType="versatile" />
          </b-th>
          <b-th class="text-center defense">
            <UnmatchedCardIcon class="icon-padfix" cardType="defence" />
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-for="{ name, data, isChar } in allStats">
          <b-tr :key="name + '_own'">
            <b-th>
              {{ name }}
              <small
                class="text-muted"
                v-if="isChar"
                :class="{ hidden: !includeAny || allStats.length === 1 }"
                >+ ANY</small
              >
            </b-th>
            <template v-for="selectedData in ['unique', 'count', 'value']">
              <b-td
                :key="selectedData + '_a'"
                class="text-center attack"
                :class="{ 'include-versatile': includeVersatile }"
                ><span>{{
                  includeVersatile
                    ? data.totalAttack[selectedData]
                    : data.attack[selectedData]
                }}</span></b-td
              >
              <b-td :key="selectedData + '_v'" class="text-center versatile">{{
                data.versatile[selectedData]
              }}</b-td>
              <b-td
                :key="selectedData + '_d'"
                class="text-center defense"
                :class="{ 'include-versatile': includeVersatile }"
                ><span>{{
                  includeVersatile
                    ? data.totalDefence[selectedData]
                    : data.defence[selectedData]
                }}</span></b-td
              >
              <b-td
                :key="selectedData + '_s'"
                v-if="selectedData !== 'value'"
                class="text-center scheme"
                >{{ data.scheme[selectedData] }}</b-td
              >
              <b-th
                :key="selectedData + '_t'"
                v-if="selectedData !== 'value'"
                class="text-center total"
                >{{ data[selectedData] }}</b-th
              >
            </template>
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>
    <DeckHistogram :cards="cards" />
  </div>
</template>

<script>
import UnmatchedCardIcon from "@/components/UnmatchedCardIcon.vue";
import DeckHistogram from "@/components/DeckHistogram.vue";

import Stats from "@/deckstats";

export default {
  name: "DeckAnalysis",
  props: {
    cards: Array,
  },
  components: { UnmatchedCardIcon, DeckHistogram },
  data() {
    return {
      selectedData: "unique",
      options: [
        { value: "unique", text: "Unique card count" },
        { value: "count", text: "Total card count" },
        { value: "value", text: "Total card value" },
      ],
    };
  },
  computed: {
    includeAny: {
      get() {
        if ("includeAny" in this.$store.state.userPreferences) {
          return this.$store.state.userPreferences.includeAny;
        }
        return true;
      },
      set(value) {
        this.$store.commit("setPreference", {
          key: "includeAny",
          value: value,
        });
      },
    },
    includeVersatile: {
      get() {
        if ("includeVersatile" in this.$store.state.userPreferences) {
          return this.$store.state.userPreferences.includeVersatile;
        }
        return false;
      },
      set(value) {
        this.$store.commit("setPreference", {
          key: "includeVersatile",
          value: value,
        });
      },
    },
    stats() {
      return this.cards.reduce(
        (stats, card) => {
          stats.all.update(card);

          const characterName = card.characterName.toLocaleUpperCase();

          if (characterName === "ANY") {
            stats.any.update(card);
          } else {
            if (!(characterName in stats.byCharacter))
              stats.byCharacter[characterName] = new Stats();

            const characterStats = stats.byCharacter[characterName];

            characterStats.update(card);
          }

          return stats;
        },
        {
          all: new Stats(),
          any: new Stats(),
          byCharacter: {},
        }
      );
    },
    disableAnyCheckbox() {
      const numCharacters = Object.entries(this.stats.byCharacter).length;
      return this.stats.any.unique === 0 || numCharacters === 0;
    },
    allStats() {
      const byCharacter = Object.entries(this.stats.byCharacter).map(
        ([name, data]) => {
          return {
            name,
            isChar: true,
            data: this.includeAny ? data.add(this.stats.any) : data,
          };
        }
      );
      if (this.stats.any.unique) {
        byCharacter.push({ name: "ANY", data: this.stats.any });
      }
      if (byCharacter.length > 1) {
        byCharacter.push({ name: "TOTAL", data: this.stats.all });
      }
      return byCharacter;
    },
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/mixins";

.hidden {
  visibility: hidden;
}

.attack {
  background-color: @attack-red;
  color: #fff;
  &.include-versatile {
    text-shadow: @attack-red 5px 0px 0px, @attack-red 4.90033px 0.993347px 0px,
      @attack-red 4.60531px 1.94709px 0px, @attack-red 4.12668px 2.82321px 0px,
      @attack-red 3.48353px 3.58678px 0px, @attack-red 2.70151px 4.20736px 0px,
      @attack-red 1.81179px 4.6602px 0px, @attack-red 0.849836px 4.92725px 0px,
      @attack-red -0.145998px 4.99787px 0px,
      @attack-red -1.13601px 4.86924px 0px, @attack-red -2.08073px 4.54649px 0px,
      @attack-red -2.94251px 4.04248px 0px, @attack-red -3.68697px 3.37732px 0px,
      @attack-red -4.28444px 2.57751px 0px, @attack-red -4.71111px 1.67494px 0px,
      @attack-red -4.94996px 0.7056px 0px,
      @attack-red -4.99147px -0.291871px 0px,
      @attack-red -4.83399px -1.27771px 0px,
      @attack-red -4.48379px -2.2126px 0px,
      @attack-red -3.95484px -3.05929px 0px,
      @attack-red -3.26822px -3.78401px 0px,
      @attack-red -2.4513px -4.35788px 0px,
      @attack-red -1.53666px -4.75801px 0px,
      @attack-red -0.560763px -4.96845px 0px,
      @attack-red 0.437495px -4.98082px 0px,
      @attack-red 1.41831px -4.79462px 0px, @attack-red 2.34258px -4.41727px 0px,
      @attack-red 3.17346px -3.86382px 0px, @attack-red 3.87783px -3.15633px 0px,
      @attack-red 4.4276px -2.32301px 0px, @attack-red 4.80085px -1.39708px 0px,
      @attack-red 4.98271px -0.415447px 0px;
    background-image: linear-gradient(
      45deg,
      @attack-red 25%,
      @versatile-violet 25%,
      @versatile-violet 50%,
      @attack-red 50%,
      @attack-red 75%,
      @versatile-violet 75%,
      @versatile-violet 100%
    );
    background-size: 1em 1em;
  }
}

.a-v {
  background: linear-gradient(90deg, @attack-red 0%, @versatile-violet 100%);
  background-image: linear-gradient(
    45deg,
    @attack-red 25%,
    @versatile-violet 25%,
    @versatile-violet 50%,
    @attack-red 50%,
    @attack-red 75%,
    @versatile-violet 75%,
    @versatile-violet 100%
  );
  background-size: 24px 24px;
  color: #fff;
}

.defense {
  background-color: @defence-blue;
  color: #fff;
  &.include-versatile {
    text-shadow: @defence-blue 5px 0px 0px,
      @defence-blue 4.90033px 0.993347px 0px,
      @defence-blue 4.60531px 1.94709px 0px,
      @defence-blue 4.12668px 2.82321px 0px,
      @defence-blue 3.48353px 3.58678px 0px,
      @defence-blue 2.70151px 4.20736px 0px,
      @defence-blue 1.81179px 4.6602px 0px,
      @defence-blue 0.849836px 4.92725px 0px,
      @defence-blue -0.145998px 4.99787px 0px,
      @defence-blue -1.13601px 4.86924px 0px,
      @defence-blue -2.08073px 4.54649px 0px,
      @defence-blue -2.94251px 4.04248px 0px,
      @defence-blue -3.68697px 3.37732px 0px,
      @defence-blue -4.28444px 2.57751px 0px,
      @defence-blue -4.71111px 1.67494px 0px,
      @defence-blue -4.94996px 0.7056px 0px,
      @defence-blue -4.99147px -0.291871px 0px,
      @defence-blue -4.83399px -1.27771px 0px,
      @defence-blue -4.48379px -2.2126px 0px,
      @defence-blue -3.95484px -3.05929px 0px,
      @defence-blue -3.26822px -3.78401px 0px,
      @defence-blue -2.4513px -4.35788px 0px,
      @defence-blue -1.53666px -4.75801px 0px,
      @defence-blue -0.560763px -4.96845px 0px,
      @defence-blue 0.437495px -4.98082px 0px,
      @defence-blue 1.41831px -4.79462px 0px,
      @defence-blue 2.34258px -4.41727px 0px,
      @defence-blue 3.17346px -3.86382px 0px,
      @defence-blue 3.87783px -3.15633px 0px,
      @defence-blue 4.4276px -2.32301px 0px,
      @defence-blue 4.80085px -1.39708px 0px,
      @defence-blue 4.98271px -0.415447px 0px;
    background-image: linear-gradient(
      45deg,
      @versatile-violet 25%,
      @defence-blue 25%,
      @defence-blue 50%,
      @versatile-violet 50%,
      @versatile-violet 75%,
      @defence-blue 75%,
      @defence-blue 100%
    );
    background-size: 1em 1em;
  }
}

.v-d {
  background: linear-gradient(90deg, @versatile-violet 0%, @defence-blue 100%);
  background-image: linear-gradient(
    45deg,
    @versatile-violet 25%,
    @defence-blue 25%,
    @defence-blue 50%,
    @versatile-violet 50%,
    @versatile-violet 75%,
    @defence-blue 75%,
    @defence-blue 100%
  );
  background-size: 24px 24px;
  color: #fff;
}

.versatile {
  background-color: @versatile-violet;
  color: #fff;
}

.scheme {
  background-color: @scheme-yellow;
  color: #fff;
}

th {
  &.attack,
  &.defense,
  &.versatile,
  &.scheme {
    min-width: 2.1rem;
  }
}

.table {
  border-color: white;
}
</style>
